import { createContext} from "react";

const studentContext = createContext();

export default studentContext